<div class="content-login">
  <ng-container *ngIf="isProduction; else elseProduction">
    <div class="row production content-image">
      <div class="col-11 col-md-10 col-lg-9 mx-auto">
        <div class="card p-5">
          <form [formGroup]="formLogin" class="row justify-content-center" (submit)="zohoSend()" autocomplete="off"
            novalidate>
            <div class="col-12 col-lg-5">
              <p class="fs-4 fw-bold mb-4">Garanta seu acesso antecipado</p>
              <p class="fs-5 fw-bold">Seja um dos primeiros a experimentar a LadyBank!</p>
              <p class="fs-5">Estamos liberando o acesso à plataforma de forma gradual para garantir a melhor experiência durante o lançamento.</p>
              <p class="fs-5">Cadastre-se para entrar na fila de acesso antecipado e receba seu convite assim que seu grupo for liberado.</p>
              <p class="fs-5 fw-bold mb-4">Recebeu um código de convite?</p>
              <p class="fs-5">Informe-o durante o cadastro para antecipar sua posição na fila de acesso.</p>
              <div class="row gap-0 row-gap-3 mt-4">
                <div class="col-12 col-lg-6 form-group">
                  <label for="firstName">Nome</label>
                  <input type="text" class="form-control" formControlName="firstName" maxlength="50">
                  <invalid-feedback [field]="f.firstName"></invalid-feedback>
                </div>
                <div class="col-12 col-lg-6 form-group">
                  <label for="lastName">Sobrenome</label>
                  <input type="text" class="form-control" formControlName="lastName" maxlength="50">
                  <invalid-feedback [field]="f.lastName"></invalid-feedback>
                </div>
                <div class="col-12 col-lg-6 form-group">
                  <label for="phone">WhatsApp</label>
                  <input type="text" class="form-control" Mask="(##) #####-####" placeholder="(00) 00000-0000"
                    formControlName="phone">
                  <invalid-feedback [field]="f.phone"></invalid-feedback>
                </div>
                <div class="col-12 col-lg-6 form-group">
                  <label for="phone">Código de convite <span class="fs-8">(opcional)</span></label>
                  <input type="text" class="form-control ng-invalid-fake" formControlName="token" (blur)="verifyField()">
                  <invalid-feedback [field]="f.token" label="Código"></invalid-feedback>
                </div>
                <div class="col-12 form-group">
                  <label for="email">E-mail</label>
                  <input type="text" class="form-control" placeholder="email@exemplo.com" formControlName="email"
                    maxlength="128">
                  <invalid-feedback [field]="f.email"></invalid-feedback>
                </div>
              </div>
            </div>
            <div class="d-none d-lg-block col-lg-6 mx-auto">
              <p class="fs-5 fw-bold mx-4">Liberação de acesso</p>
              <div class="card border-2 rounded-4 p-3" style="background-color: #CE756F;">
                <p class="mb-0 fw-bold text-white">Grupo atualmente em liberação: Grupo 2</p>
                <p class="mb-0 fw-bold text-white">Seu grupo ao se cadastrar hoje: Grupo 5</p>
              </div>
              <p class="fs-5 mx-4 mt-3 mb-5">Quando chegar a sua vez, enviaremos um e-mail com as instruções de acesso.</p>
              <img src="assets/images/png/robo.png" class="w-100" alt="robo">
            </div>
            <div class="col-12 text-center my-1 mt-lg-5">
              <button class="btn btn-outline-primary px-5" type="button" (click)="back()">VOLTAR</button>
              <button class="btn btn-primary px-5" type="submit">
                GARANTIR MEU ACESSO
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #elseProduction>
    <div class="content-image">
      <div class="col-11 col-md-7 col-lg-5 col-xl-4 mx-auto">
        <div class="card">
          <div class="card-title text-center mx-5 mt-4">
            <a href="/" class="d-flex justify-content-center">
              <img src="assets/images/png/logo_ladybank_lg.png" alt="">
            </a>
            <p class="mt-3 poppins-bold text-center fs-2">
              Fazer Login
            </p>
          </div>
          <div class="card-body mx-5">
            <form [formGroup]="formLogin" class="row gap-3 justify-content-center" (submit)="login($event)"
              [autocomplete]="autocomplete ? 'on' : 'off'" novalidate>
              <div class="form-title col-12 text-center mb-2">
                <span class="fs-5 fw-semibold">Por favor, informe seus dados</span>
              </div>
              <div class="form-group">
                <label for="login">E-mail, CPF ou CNPJ</label>
                <input type="email" class="form-control" placeholder="" formControlName="login" (blur)="verifyField()"
                  maxlength="128">
                <div *ngIf="(!f.login.pristine || f.login.touched) && f.login.errors" class="invalid-feedback fs-8">
                  <div *ngIf="f.login.errors.required"> Campo obrigatório. </div>
                  <div *ngIf="f.login.errors.invalid"> E-mail ou Documento inválido </div>
                </div>
              </div>
              <div class="form-group">
                <label for="password">Senha</label>
                <div class="input-group">
                  <input [type]="typeInput" id="password" name="password" class="form-control border-end-0"
                    placeholder="&exemplo1" formControlName="password">
                  <div class="input-group-text bg-transparent rounded-end"
                    [ngClass]="{'border border-danger border-start-0': (!f.password.pristine || f.password.touched) && f.password.errors }">
                    <em class="material-icons pointer" (click)="previewPassword()">{{iconPassword}}</em>
                  </div>
                  <div *ngIf="(!f.password.pristine || f.password.touched) && f.password.errors"
                    class="invalid-feedback fs-8">
                    <div *ngIf="f.password.errors.required"> Campo obrigatório. </div>
                    <div *ngIf="!f.password.errors.required && f.password.errors.invalidPassword"> A senha deve conter
                      no mínimo 6 caracteres, 1 número e 1 caractere especial. </div>
                  </div>

                </div>
              </div>
              <div class="d-flex justify-content-between fs-8">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" id="remember" [(ngModel)]="autocomplete"
                    [ngModelOptions]="{standalone: true}">
                  <label class="form-check-label" for="remember">Relembrar</label>
                </div>
                <label class="text-primary m-0 p-0" role="button" (click)="onForgotPassword()">Esqueci a senha</label>
              </div>
              <div class="row mt-4">
                <button class="btn btn-outline-primary col my-1" type="button" (click)="back()">VOLTAR</button>
                <button class="btn btn-primary col my-1" type="submit" [disabled]="!formLogin.valid">ENTRAR</button>
              </div>
              <div class="d-flex justify-content-center align-items-center py-2 mt-3">
                <label>Ainda não é cliente? <a class="pointer" (click)="onOpenAccount()">Cadastre-se</a></label>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>